import { render, staticRenderFns } from "./WorkshopsList.vue?vue&type=template&id=1e01140a&scoped=true&"
import script from "./WorkshopsList.vue?vue&type=script&lang=js&"
export * from "./WorkshopsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsList.vue?vue&type=style&index=0&id=1e01140a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01140a",
  null
  
)

export default component.exports